import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import NoDataComponent from '../../../common/NoDataComponent'; // Import the new component
import { dateToDDMMYYY, dateToTime, secondsToTime } from '../../../utils/timeCalculation';

const TimeSheetReport = ({ data }) => (
  <Grid container style={{ paddingTop: '8%' }}>
    <Grid item xs={12} className="report-heading" style={{ marginTop: '10px' }}>
      Timesheet Report
    </Grid>
    {data?.table?.length > 0 ? (
      <>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 50 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ padding: '5px' }}>Day</TableCell>
                  <TableCell style={{ padding: '5px' }}>Task</TableCell>
                  <TableCell style={{ padding: '5px' }}>Start - End</TableCell>
                  <TableCell style={{ padding: '5px' }}>Duration</TableCell>
                  <TableCell style={{ padding: '5px' }}>Employee</TableCell>
                  <TableCell style={{ padding: '5px' }}>Client</TableCell>
                  <TableCell style={{ padding: '5px' }}>Project</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.table.map((row, i) => (
                  <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell style={{ padding: '5px' }}>{dateToDDMMYYY(row?.startTime)}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{row.tasks?.taskName}</TableCell>
                    <TableCell style={{ padding: '5px' }}>
                      {dateToTime(row?.startTime)} -{row?.stopTime ? dateToTime(row?.stopTime) : 'is working'}
                    </TableCell>
                    <TableCell style={{ padding: '5px' }}>{secondsToTime(row?.duration ?? 0)}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{row.tasks?.user?.userName}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{row.tasks?.projects?.clients?.clientName}</TableCell>
                    <TableCell style={{ padding: '5px' }}>{row.tasks?.projects?.projectName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </>
    ) : (
      <>
        <NoDataComponent />
      </>
    )}
  </Grid>
);

TimeSheetReport.propTypes = {
  data: PropTypes.object.isRequired,
};

export default TimeSheetReport;
